import settingsModule from '../../settings.module';
import template from './accountAuthenticationSpMetadata.component.html';
import beautify from 'xml-beautifier';

export default settingsModule.component('accountAuthenticationSpMetadata', {
    template,
    bindings: {
        resolve: '<',
        close: '&',
        dismiss: '&'
    },
    controller($window) {
        const vm = this;

        vm.$onInit = () => {
            vm.spMetadata = beautify(vm.resolve.spMetadata);
            vm.hideCopyButton = false;
            const blob = new Blob([vm.spMetadata], { type: 'application/xml' });
            const url = $window.URL || $window.webkitURL;
            vm.fileUrl = url.createObjectURL(blob);
            vm.fileName = 'metadata.xml';
        };

        vm.close = () => {
            vm.dismiss({ $value: { close: true } });
        };
    }
});



// WEBPACK FOOTER //
// ./modules/settings/components/accountAuthentication-sp-metadata/accountAuthenticationSpMetadata.component.js